import {useAuthStore} from "@src/stores/auth";
import "@src/services/echo";
import {useChatSessions} from "@src/composables/useChatSessions";

export function StartConversationListener() {
    const userStore = useAuthStore();
    const {sessionExistsByToken, newSession} = useChatSessions();

    const userId = userStore.user?.id;
    if (!userId) return;

    // @ts-ignore
    window.websockets
        .private(`user.${userId}`)
        .listen(".NewStartConversation", async (event: any) => {
            const session = event.session;

            if (await sessionExistsByToken(session.costumer.token, session.channel.type)) {
                return;
            }
            await newSession(session);
        });
}